export default __webpack_public_path__ + "static/media/1278.707beb7d.jpg";